import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExternalViewContextService } from '@context/frontend/user';

/**
 * Entry point for a share link (`/view/:externalId`).
 *
 * By the time this mounts, {@link ExternalViewAuthGuard} has already validated the
 * link and established the share session, storing the lookup in
 * {@link ExternalViewContextService}. This component does nothing but forward the
 * viewer to the typed content stack (`/content/:externalId/(folder|file)/:id`); it
 * is never visible for more than a frame.
 *
 * Keeping the proxy on its own route - separate from the content stack - means the
 * auth guard runs exactly once. Previously the typed segments were appended to the
 * same `view/:externalId` route, which re-triggered its guard and resolver.
 */
@Component({
	standalone: true,
	selector: 'ctx-external-view-proxy',
	template: '',
})
export class ExternalViewProxyComponent implements OnInit {
	private readonly context = inject(ExternalViewContextService);
	private readonly router = inject(Router);

	ngOnInit(): void {
		const ctx = this.context.data();
		if (!ctx) {
			this.router.navigate(['/']);
			return;
		}

		this.router.navigate(
			['/content', ctx.externalId, ctx.type, ctx.contentId],
			{ replaceUrl: true },
		);
	}
}
